import React from 'react';

import styles from './styles/tech-box.module.css';

export default function TechBox({ tech, title, content }) {
  return (
    <div className={styles.wrapper}>
        <div>{tech}</div>
        <div className={styles.boxText}>
            <p>{title}</p>
            <p>{content}</p>
        </div>
    </div>
  );
}
